import {
	INITIAL_STATE as userState,
	PERSISTED_STATE as persistedUserState,
	REDUCER as userReducer,
} from "./user/reducers";
import {
	INITIAL_STATE as sidebarState,
	PERSISTED_STATE as persistedSidebarState,
	REDUCER as sidebarReducer,
} from "./sidebar/reducers";
import {
	INITIAL_STATE as authState,
	PERSISTED_STATE as persistedAuthState,
	REDUCER as authReducer,
} from "./auth/reducers";
import {
	INITIAL_STATE as companyState,
	PERSISTED_STATE as persistedCompanyState,
	REDUCER as companyReducer,
} from "./company/reducers";
import {
	INITIAL_STATE as externalState,
	PERSISTED_STATE as persistedExternalState,
	REDUCER as externalReducer,
} from "./external/reducers";
import {
	INITIAL_STATE as themeState,
	PERSISTED_STATE as persistedThemeState,
	REDUCER as themeReducer,
} from "./theme/reducers";
import { INITIAL_STATE as alarmState, REDUCER as alarmReducer } from "./alarm/reducers";

export const CLEAR_STATES = "root/CLEAR_STATES";

const initialStates = {
	user: userState,
	auth: authState,
	company: companyState,
	sidebar: sidebarState,
	external: externalState,
	theme: themeState,
	alarm: alarmState,
};

export const persistedStates = {
	...initialStates,
	user: persistedUserState,
	auth: persistedAuthState,
	sidebar: persistedSidebarState,
	company: persistedCompanyState,
	external: persistedExternalState,
	theme: persistedThemeState,
};

export const reducers = ({ user, auth, company, sidebar, external, theme, alarm }, action) => {
	if (action.type === CLEAR_STATES) {
		return initialStates;
	} else {
		return {
			user: userReducer(user, action),
			auth: authReducer(auth, action),
			company: companyReducer(company, action),
			sidebar: sidebarReducer(sidebar, action),
			external: externalReducer(external, action),
			theme: themeReducer(theme, action),
			alarm: alarmReducer(alarm, action),
		};
	}
};
